import { styled } from "@mui/material/styles";

export const CustomDiv = styled("div")({
  padding: "3rem",
  justifyContent: "center",
  width: "100%",
  maxWidth: "80rem",
  display: "flex",
});
